import type { EditAction } from '@/lib/ai-composer/types';

export interface AiActionPick {
  action: EditAction;
  params?: Record<string, string>;
}

export interface AiActionLanguage {
  label: string;
  value: string;
}

export interface AiActionTemplate {
  id: string;
  name: string;
}

export interface AiActionItem {
  action: EditAction | 'generate-from-selection';
  label: string;
  run?: () => void;
  languages?: AiActionLanguage[];
  templates?: AiActionTemplate[];
  dividerBefore?: boolean;
}

const LANGUAGES: AiActionLanguage[] = [
  { label: 'Spanish', value: 'Spanish' },
  { label: 'French', value: 'French' },
  { label: 'German', value: 'German' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Korean', value: 'Korean' },
];

export interface BuildAiActionItemsOptions {
  allowChart: boolean;
  onPick: (pick: AiActionPick) => void;
  selectionTemplates?: readonly AiActionTemplate[];
  onGenerateFromSelection?: (templateId: string | null) => void;
}

export function buildAiActionItems({
  allowChart,
  onPick,
  selectionTemplates,
  onGenerateFromSelection,
}: BuildAiActionItemsOptions): AiActionItem[] {
  const items: AiActionItem[] = [];

  if (allowChart) {
    items.push({
      action: 'generate-chart',
      label: 'Generate chart',
      run: () => onPick({ action: 'generate-chart' }),
    });
  }

  items.push({
    action: 'organize',
    label: 'Organize',
    run: () => onPick({ action: 'organize' }),
  });

  items.push({
    action: 'translate',
    label: 'Translate',
    languages: LANGUAGES.map((lang) => ({
      label: lang.label,
      value: lang.value,
    })),
    run: undefined,
  });

  if (onGenerateFromSelection && selectionTemplates && selectionTemplates.length > 0) {
    items.push({
      action: 'generate-from-selection',
      label: 'Generate from selection',
      templates: selectionTemplates.map(({ id, name }) => ({ id, name })),
      dividerBefore: true,
    });
  }

  return items;
}
